import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { observer, inject } from "mobx-react";
import { GridRow, GridColumn, LazyImg } from "arv-reactcomponents";

import { ROUTE_PATHS, pageType, Endpoints } from "npmlinks-constants";
import ProductActions from "../ProductActions";
import QuantityView from "../QuantityView";
import OosView from "../OosView";
import ProductDescription from "../ProductDescription";
import ProductPriceBlock from "../ProductPriceBlock";
import DeliveryOptions from "../DeliveryOptions";
import AppliedPromotionsView from "../AppliedPromotionsView";
import Anchor from "../../Anchor";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

@inject("CheckoutStore", "CommonStore")
@observer
@withRouter
class CartProductView extends Component {
  static triggerGaOnProductClick() {
    if (window.pageType === pageType.myBag) {
      Analytics.trackEvent({
        category: window.pageType,
        action: Event.action.MYBAG_PRODUCT_CLICK,
      });
    }
  }
  constructor(props) {
    super(props);

    this.state = {
      defaultMainImage: null,
    };

    this.onMainImgError = this.onMainImgError.bind(this);
    this.currentTarget = this.currentTarget.bind(this);
  }
  get currentView() {
    const { location: { pathname } } = this.props;
    return pathname === ROUTE_PATHS.MYBAG ? "mybag" : "checkout";
  }

  get showDeliveryOptions() {
    const { product: { deliveryDetails, storeCount } } = this.props;
    return this.currentView !== "mybag" && (deliveryDetails || storeCount > 0);
  }
  get image() {
    const { product } = this.props;
    return (product && product.thumbnailImage) || (product && product.image) || Endpoints.noImg;
  }
  get instock() {
    const { product } = this.props;
    return product.sellableQty > 0; // now logic is ulta
  }
  get notDeliverable() {
    const isCheckout = this.currentView !== "mybag";
    const { product } = this.props;
    return isCheckout && !product.shippingMethod;
  }
  get showQuantity() {
    const { loading } = this.props.CheckoutStore;
    return this.instock && !this.notDeliverable && !loading;
  }
  get showOos() {
    const { loading } = this.props.CheckoutStore;
    return (!this.instock || this.notDeliverable) && !loading;
  }
  get productUrl() {
    const { product: { url } } = this.props;
    return this.currentView === "mybag" ? url : "";
  }
  onMainImgError() {
    this.setState({
      defaultMainImage: Endpoints.noImg,
    });
  }
  currentTarget() {
    const { isDesktop } = this.props.CommonStore;
    return (isDesktop && "_blank") || "_self";
  }
  render() {
    const { defaultMainImage } = this.state;
    const { product } = this.props;
    const { loading } = this.props.CheckoutStore;
    const isMybag = this.currentView === "mybag";
    return (
      <GridRow className="nw-cartproductview">
        {this.showOos && (
          <OosView.component
            loading={loading}
            product={product}
            instock={this.instock}
          />
        )}
        <GridColumn className={`nwc-grid-col-sm-${isMybag ? "12" : "6"}`}>
          <GridRow>
            <GridColumn className="nwc-grid-col-sm nw-cartproductview-imagecontainer">
              <Anchor.component
                to={this.productUrl}
                href={this.productUrl}
                target={this.currentTarget()}
                onClick={CartProductView.triggerGaOnProductClick}
              >
                <LazyImg
                  className="nw-cartproductview-image"
                  src={defaultMainImage || this.image}
                  offset={300}
                  onError={this.onMainImgError}
                  onWinLoad
                />
              </Anchor.component>
            </GridColumn>
            <GridColumn className="nwc-grid-col-xs nw-cartproductview-actionscontainer">
              <GridRow className="nw-cartproductview-attributes">
                <ProductDescription.component
                  currentView={this.currentView}
                  product={product}
                />
                {isMybag &&
                  !this.showOos && <QuantityView.component product={product} />}
                {!this.showOos && (
                  <ProductPriceBlock.component
                    currentView={this.currentView}
                    product={product}
                  />
                )}
              </GridRow>
              <AppliedPromotionsView.component product={product} />
              {isMybag &&
                !this.showOos && <ProductActions.component product={product} />}
            </GridColumn>
          </GridRow>
        </GridColumn>
        {this.showDeliveryOptions && (
          <GridColumn className="nw-cartproductview-deloptscontainer nwc-grid-col-sm-6">
            <DeliveryOptions.component product={product} />
          </GridColumn>
        )}
      </GridRow>
    );
  }
}

CartProductView.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  product: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CheckoutStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: CartProductView.wrappedComponent,
  component: CartProductView,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CartProducts/CartProductView/index.js